/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { HTTP_METHOD } from "@nf/constants";
import { httpService } from "../../../../services";
import {
  ISelectUserSubprofileResponseModel,
  IUserSubprofileListModel,
  IUserSubprofileRequestModel,
  IUserSubprofileResponseModel,
} from "../models";

export class UserSubprofilesService {
  get url(): string {
    return `/v2/user/profile`;
  }

  public getUserSubprofiles = (): Promise<IUserSubprofileListModel> =>
    httpService.request<IUserSubprofileListModel>({
      method: HTTP_METHOD.GET,
      url: `${this.url}`,
    });

  public createUserSubprofile = (
    data: IUserSubprofileRequestModel
  ): Promise<IUserSubprofileListModel> => {
    return httpService.request<IUserSubprofileListModel>({
      data,
      method: HTTP_METHOD.POST,
      url: `${this.url}`,
    });
  };

  public updateUserSubprofile = (
    data: IUserSubprofileRequestModel,
    id: string | number
  ): Promise<IUserSubprofileResponseModel> =>
    httpService.request<IUserSubprofileResponseModel>({
      data,
      method: HTTP_METHOD.PUT,
      url: `${this.url}/${id}`,
    });

  public deleteUserSubprofile = (
    subprofileId: string | number
  ): Promise<void> =>
    httpService.request<void>({
      method: HTTP_METHOD.DELETE,
      url: `${this.url}/${subprofileId}`,
    });

  public selectUserSubprofile = (
    subprofileId: string | number
  ): Promise<ISelectUserSubprofileResponseModel> =>
    httpService.request<ISelectUserSubprofileResponseModel>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/${subprofileId}/select`,
    });
}
